import { Component } from '@angular/core';

import { ControlWidget } from 'ngx-schema-form';
import { TinyMCEComponent } from './tinymce.component';
import { TinyMCEValueAccessor } from './tinymce.valueaccessor';


export let getHtmlSchemaForm = function (description: string = null) {
    return {
        type: 'string',
        description: description,
        widget: {
            id: 'tinymce',
            plugins: 'code',
            toolbar: 'forecolor backcolor code',
            menubar: 'forecolor backcolor code',
        },
    };
};
